<div class="form-floating" [class]="classes">
  <select class="form-select" [ngClass]="{'pe-none': readonly}" [disabled]="readonly" [class]="selectClasses" [id]="id"
    [value]="value" (change)="setValue($event)">
    <option value="" selected disabled>{{selectOptionTitle}}</option>
    <option *ngFor="let option of selectOptions" [value]="option.value">{{option.text}}</option>
  </select>
  <label [for]="id" [class]="labelClasses">{{label}}</label>
</div>